<template>
  <div class="md-layout page-review-step1">
    <div class="md-layout-item md-size-100">
      <div v-if="showMap">
        <div>
          <span class="fs-12">
            (Tip: Contact info will be disclosed after your booking.)
          </span>
        </div>
        <ReviewerMap
          :reviewerNumberCbfn="reviewerNumberCbfn"
          :bookingCbfn="bookingCbfn"
        />
      </div>
    </div>
    <Notifications />
  </div>
</template>
<script>
import ReviewerMap from "@/pages/Dashboard/Components/ReviewerMap.vue";
import { mapFields } from "vuex-map-fields";
import { PILOT_NETWORK } from "@/const";
import { checkUserRoles } from "@/services/flightReview.service.js";

export default {
  $_veeValidate: {
    validator: "new"
  },
  components: {
    ReviewerMap
  },
  data() {
    return {
      showMap: false, // to fix first style mass
      reviewerNumber: "--",
      maacReviewerWithoutClubForPublic: false,
      onlyForPublicService: false
    };
  },
  computed: {
    ...mapFields("flightReview", ["booking"]),
  },
  methods: {
    initMap() {
      this.showMap = true;
    },
    async bookingCbfn(reviewerInfo, isMAACMember) {
      if (reviewerInfo._id) {
        // Maac Reviewer Without Club But For Public Client
        if (
          !this.booking.clubId &&
          reviewerInfo.pilot_network === PILOT_NETWORK.MAAC_REVIEWER &&
          !isMAACMember
        ) {
          this.maacReviewerWithoutClubForPublic = true;
          return;
        }

        // onlyForPublicService
        if (reviewerInfo.pilot_network === PILOT_NETWORK.PUBLIC_SERVICE_REVIEWER) {
          const { public: public_service } = await checkUserRoles();
          if (!public_service) {
            this.onlyForPublicService = true
            return
          }
        }

        if (reviewerInfo.pilot_network === PILOT_NETWORK.MAAC_CLUB) {
          this.$store.commit("flightReview/updateBooking", {
            reviewerId: "",
            clubId: reviewerInfo.reviewer_id,
            addressId: reviewerInfo._id.$oid,
          });
        } else {
          this.$store.commit("flightReview/updateBooking", {
            reviewerId: reviewerInfo.reviewer_id,
            clubId: "",
            addressId: reviewerInfo._id.$oid,
          });
        }
      } else {
        this.$store.commit("flightReview/updateBooking", {
          reviewerId: "",
          clubId: "",
          addressId: ""
        });
      }
    },
    validate() {
      if (this.booking.reviewerId && this.booking.selectedPackageKeys.length) {
        return true;
      } else if (this.onlyForPublicService) {
        this.$notify({
          message: this.$t(
            "Only public service clients can book with this flight reviewer."
          ),
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "warning",
          timeout: 3000
        });
      } else if (this.maacReviewerWithoutClubForPublic) {
        this.$notify({
          message: this.$t(
            "Only MAAC members can book with this flight reviewer."
          ),
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "warning",
          timeout: 3000
        });
      } else if (this.booking.selectedPackageKeys.length ===0) {
        this.$notify({
          message: this.$t("Please select a package"),
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "warning",
          timeout: 3000
        });
      } else {
        this.$notify({
          message: this.$t("Please select a flight reviewer"),
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "warning",
          timeout: 3000
        });
      }
    },
    reviewerNumberCbfn(num) {
      this.reviewerNumber = num;
    }
  },
  watch: {},
  mounted() {}
};
</script>

<style lang="css">
.page-review-step1 {
  .subtitle {
    color: #333;
    font-size: 14px;
    font-weight: 500;
  }
  .fs-12 {
    font-size: 12px;
  }
}
</style>
